import { render } from "./LoginInputPhone.vue?vue&type=template&id=609f4ad1&scoped=true"
import script from "./LoginInputPhone.vue?vue&type=script&lang=js"
export * from "./LoginInputPhone.vue?vue&type=script&lang=js"

import "./LoginInputPhone.vue?vue&type=style&index=0&id=609f4ad1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609f4ad1"]])

export default __exports__